import { PrismicNextImage } from '@prismicio/next';
import { Content, isFilled } from '@prismicio/client';

type WithImageProps = {
  content: Content.PageHeroHeadlineSliceWithImagePrimary;
};

export const WithImage = ({ content }: WithImageProps) => {
  const { image } = content;

  if (!isFilled.image(image)) {
    return null;
  }

  return (
    <figure className="feature-img">
      <PrismicNextImage field={image} width={400} />
    </figure>
  );
};
